<template>
  <div
    class="card-illustration"
    :class="{ 'card-illustration--tall': tall }"
    :style="{ background: theme.gradient }"
    aria-hidden="true"
  >
    <img
      class="card-illustration__motif"
      :src="theme.motifSrc"
      alt=""
      width="120"
      height="80"
      decoding="async"
    />
    <span class="card-illustration__wash"></span>
  </div>
</template>

<script>
import { resolveCardIllustration } from '@/utils/cardIllustration'

export default {
  name: 'CardIllustrationStrip',
  props: {
    destination: { type: String, default: '' },
    destinationId: { type: String, default: '' },
    name: { type: String, default: '' },
    /** Slightly taller strip for browse grid cards */
    tall: { type: Boolean, default: false },
  },
  computed: {
    theme() {
      return resolveCardIllustration({
        destination: this.destination,
        destination_id: this.destinationId,
        name: this.name,
      })
    },
  },
}
</script>

<style scoped>
.card-illustration {
  position: relative;
  height: 88px;
  width: 100%;
  flex-shrink: 0;
  overflow: hidden;
}

.card-illustration--tall {
  height: 96px;
}

.card-illustration__motif {
  position: absolute;
  right: 8px;
  bottom: 4px;
  width: 96px;
  height: 64px;
  object-fit: contain;
  pointer-events: none;
  user-select: none;
  opacity: 0.95;
}

.card-illustration__wash {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 35%,
    rgba(0, 0, 0, 0.12) 100%
  );
  pointer-events: none;
}

@media (max-width: 768px) {
  .card-illustration {
    height: 80px;
  }
  .card-illustration--tall {
    height: 88px;
  }
  .card-illustration__motif {
    width: 84px;
    height: 56px;
  }
}
</style>
